import styled from 'styled-components';
import dt from '../../../../shared/theme';

const Results = styled.div`
  color: ${props => dt(props).theme.bodyColor};
  font-family: ${props => dt(props).theme.fontFamilyBody};
  font-weight: ${props => dt(props).theme.fontWeightBold};
  text-transform: uppercase;
  line-height: 120%;
  font-size: 14px;

  ${props => dt(props).theme.isMobileOrTablet && `
    font-size: 12px;
  `};
`;

const Name = styled.h1`
  color: ${props => dt(props).theme.bodyColor};
  font-family: ${props => dt(props).theme.fontFamilyBody};
  font-weight: ${props => dt(props).theme.fontWeightRegular};
  line-height: 110%;
  font-size: 40px;
  margin: 0px;

  ${props => dt(props).theme.isMobileOrTablet && `
    font-size: 29px;
  `};
`;

const Description = styled.div`
  font-family: ${props => dt(props).theme.fontFamilyBody};
  font-weight: ${props => dt(props).theme.fontWeightRegular};
  color: #627484;
  line-height: 120%;
  font-size: 16px;
  margin-top: 8px;
`;

export {
  Description,
  Name,
  Results,
};
